import type { Subcategory } from '~/entities/categories'
import { getPossibleOutcomes } from './get-possible-outcomes'
import { getPossibleReasons } from './get-possible-reasons'
import { getSatisfyingCategory } from './get-satisfying-category'

export function getSatisfyingCategoryWithPreservation({
  newPhase,
  currentOutcome,
  currentReason,
  subcategories,
}: {
  newPhase: string
  currentOutcome?: string
  currentReason?: string
  subcategories: Subcategory[]
}) {
  const possibleOutcomes = getPossibleOutcomes({ phase: newPhase, subcategories })
  // Only carry a facet over when it is still selectable under the new phase — preserving a
  // dead-end value would re-select something the dropdown now refuses to offer.
  const preservedOutcome =
    currentOutcome &&
    possibleOutcomes.some((outcome) => outcome.label === currentOutcome && !outcome.isDeprecated)
      ? currentOutcome
      : undefined

  const possibleReasons = getPossibleReasons({
    phase: newPhase,
    outcome: preservedOutcome,
    subcategories,
  })
  const preservedReason =
    currentReason &&
    possibleReasons.some((reason) => reason.label === currentReason && !reason.isDeprecated)
      ? currentReason
      : undefined

  return getSatisfyingCategory({
    phase: newPhase,
    outcome: preservedOutcome,
    reason: preservedReason,
    subcategories,
  })
}
